import { connect } from "react-redux";
import Checkout from "./checkout";
import { bindActionCreators } from "redux";
import { checkoutOrder, getSitesList, addInCart } from "services/redux/brandActivtion/products/action"

const mapStateToProps = (state) => {
  return ({
    viewCart: state.productsReducer.viewCart,
    sitesData: state.productsReducer.sitesData
});}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ checkoutOrder, getSitesList, addInCart }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
